module.exports = __webpack_public_path__ + "static/media/application_denied.3b2d3086.svg";